import {cloneDeep as _cloneDeep} from 'lodash';
import CityModel from "@/models/CityModel"
const CitiesModule = {
    namespaced: true,
    state: () => ({
        city: _cloneDeep(CityModel),
        cities: [],
    }),
    getters: {
        getCity (state) {
            return state.city
        },
        getCities(state) {
            return state.cities
        },
    },
    mutations: {
        setCity (state, payload) {
            state.city = payload
        },
        setCities(state, payload) {
            state.cities = payload
        },
    },
    actions: {
        setCity (context, payload) {
            context.commit('setCity', payload);
        },
        setCities(context, payload) {
            context.commit('setCities', payload);
        },
    },
}

export default CitiesModule;
